import React from "react";
//
import { SvgIcon } from "@material-ui/core";
//
import { ReactComponent as Logo } from "assets/logo/ttms_logo.svg";

function TTMSLogo(props) {
    return <SvgIcon component={Logo} {...props} />;
}

export default TTMSLogo;
